import React from 'react'
import PropTypes from 'prop-types'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CancelIcon from '@material-ui/icons/Cancel'
import { withStyles } from '@material-ui/core/styles'

const styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  on: {
    color: '#22c55e',
  },
  off: {
    color: '#cbd5e1',
  },
}

function DeviceStatus({ classes, active, title }) {
  return (
    <span className={classes.root} title={title || (active ? '已連結' : '未連結')}>
      {active ? (
        <CheckCircleIcon className={classes.on} fontSize="small" />
      ) : (
        <CancelIcon className={classes.off} fontSize="small" />
      )}
    </span>
  )
}

DeviceStatus.propTypes = {
  classes: PropTypes.object.isRequired,
  active: PropTypes.bool,
  title: PropTypes.string,
}

export default withStyles(styles)(DeviceStatus)
